import { useState, ReactNode } from "react";
import "./CollapsibleSection.css";

interface CollapsibleSectionProps {
  title: string;
  subtitle?: string;
  count?: number;
  children: ReactNode;
  defaultCollapsed?: boolean;
}

function CollapsibleSection({
  title,
  subtitle,
  count,
  children,
  defaultCollapsed = false,
}: CollapsibleSectionProps) {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  return (
    <div className="channel-section">
      <div className="collapsible-header" onClick={toggleCollapse}>
        <span className={`collapse-icon ${collapsed ? "collapsed" : ""}`}>
          ▼
        </span>
        <div className="collapsible-header-text">
          <h2>
            {title}
            {typeof count === "number" && (
              <span className="channel-count">{count}</span>
            )}
          </h2>
          {subtitle && (
            <p className="collapsible-subtitle">{subtitle}</p>
          )}
        </div>
      </div>
      <div className={`collapsible-content ${collapsed ? "collapsed" : ""}`}>
        {children}
      </div>
    </div>
  );
}

export default CollapsibleSection;
